import React from 'react'

/*
 * Animated SVG scenes used in place of screenshots. Self-contained,
 * ~3KB each, and driven by the classes in HomeContent.scss.
 */

export const SceneReport = () => (
  <svg className="scene" viewBox="0 0 320 236" role="img"
       aria-label="A week of work reports being submitted">
    <rect className="sc-card" x="14" y="12" width="292" height="212" rx="22" />

    <circle className="sc-chip" cx="42" cy="42" r="11" />
    <rect className="sc-line" x="60" y="36" width="86" height="8" rx="4" />
    <rect className="sc-line sc-line--faint" x="60" y="49" width="54" height="7" rx="3.5" />
    <rect className="sc-pill sc-pulse" x="228" y="31" width="60" height="22" rx="11" />

    <rect className="sc-line sc-line--faint" x="36" y="78" width="64" height="7" rx="3.5" />

    <g className="sc-week">
      <rect className="sc-day sc-day-1" x="36"  y="94" width="32" height="32" rx="11" />
      <rect className="sc-day sc-day-2" x="74"  y="94" width="32" height="32" rx="11" />
      <rect className="sc-day sc-day-3" x="112" y="94" width="32" height="32" rx="11" />
      <rect className="sc-day sc-day-4" x="150" y="94" width="32" height="32" rx="11" />
      <rect className="sc-day sc-day-5" x="188" y="94" width="32" height="32" rx="11" />
      <rect className="sc-slot"         x="226" y="94" width="32" height="32" rx="11" />
      <rect className="sc-slot"         x="264" y="94" width="32" height="32" rx="11" />
    </g>

    <rect className="sc-line sc-line--faint" x="36" y="146" width="52" height="7" rx="3.5" />

    <g className="sc-bars">
      <rect className="sc-bar sc-bar-1" x="36"  y="166" width="26" height="38" rx="9" />
      <rect className="sc-bar sc-bar-2" x="72"  y="166" width="26" height="38" rx="9" />
      <rect className="sc-bar sc-bar-3" x="108" y="166" width="26" height="38" rx="9" />
      <rect className="sc-bar sc-bar-4" x="144" y="166" width="26" height="38" rx="9" />
    </g>

    <rect className="sc-panel" x="188" y="150" width="108" height="56" rx="16" />
    <path className="sc-trend" d="M202 190 L224 176 L246 182 L282 164" />
    <circle className="sc-dot" cx="282" cy="164" r="5" />
  </svg>
);

export const SceneLeave = () => (
  <svg className="scene" viewBox="0 0 320 236" role="img"
       aria-label="A leave request moving through approval">
    <rect className="sc-card" x="14" y="12" width="292" height="212" rx="22" />

    <rect className="sc-line" x="36" y="36" width="96" height="8" rx="4" />
    <rect className="sc-line sc-line--faint" x="36" y="49" width="60" height="7" rx="3.5" />

    {/* month grid */}
    <g className="sc-grid">
      {[0, 1, 2, 3, 4, 5].map((c) => (
        <rect key={`a${c}`} className="sc-cell" x={36 + c * 42} y="76" width="30" height="24" rx="9" />
      ))}
      {[0, 1, 2, 3, 4, 5].map((c) => (
        <rect key={`b${c}`} className="sc-cell" x={36 + c * 42} y="108" width="30" height="24" rx="9" />
      ))}
    </g>
    <rect className="sc-away sc-away-1" x="120" y="108" width="30" height="24" rx="9" />
    <rect className="sc-away sc-away-2" x="162" y="108" width="30" height="24" rx="9" />

    {/* the request travelling to approval */}
    <g className="sc-request">
      <rect className="sc-panel" x="36" y="152" width="180" height="54" rx="18" />
      <circle className="sc-chip" cx="64" cy="179" r="13" />
      <rect className="sc-line" x="86" y="169" width="72" height="8" rx="4" />
      <rect className="sc-line sc-line--faint" x="86" y="183" width="46" height="7" rx="3.5" />
    </g>

    <g className="sc-stamp">
      <circle className="sc-stamp-disc" cx="262" cy="179" r="26" />
      <path className="sc-stamp-tick" d="M251 179.5 L259 187.5 L274 171" />
    </g>
  </svg>
);
